'use strict'

###*
# Get responsive source tags
#
# @private
# @param   {Array}  links[]
# @returns {String}
###
getSrcTags = (links) ->
  sourceTags = ''
  links.forEach (link) ->
    srcset = link.urls_by_density.reduceRight((collection, item) ->
      [density, url] = Object.entries(item)[0] ? {}
      collection.push "#{ url } #{ density }"
      return collection
    , [])

    mediaAttr = if link.media_query?.length then ['media="' + link.media_query, '" '].join('') else ''

    if srcset.length
      sourceTags += ['<source ', mediaAttr, 'srcset="', srcset.join(', '), '">'].join('')

  return sourceTags

###*
#
# @public
# @param   {Jquery}   $picture - Jquery selector of the picture element
# @param   {Array}    links    - List of image objects with different resolutions / media queries
# @param   {Function} cb       - Image load callback (Optional)
# @returns {Boolean}           - Have the image sources been set
###
setPictureSources = ($picture, links, $wrapper, image_alt, cb) ->
  return false unless $picture?.length
  return false unless links?.length

  smallestImgUrl = links.slice(-1)[0].urls_by_density.slice(-1)[0]
  defaultImgSrc = Object.entries(smallestImgUrl)[0][1]

  sourcetags = getSrcTags(links)

  if sourcetags?.length
    $picture.prepend(sourcetags)

  $img = $picture.find('img')
  if typeof cb is 'function' then $img.one('load', cb)
  $img.attr({
    src: defaultImgSrc
    alt: image_alt
    })
  $wrapper?.prepend $picture

  return true

module.exports = {
  setPictureSources
  getSrcTags
}



// WEBPACK FOOTER //
// ./src/frontend/helper/general/m_setPictureSources.coffee